/**
 * Created by Antony Orlovsky on 09.08.19.
 */
/**
 * Animation type for paint robot.
 * @enum {String}
 * @readonly
 */
var TurtleRobotAnimation = {Paint: "paint"};

/**
 * @class 2D Sprite for {@link pm.data.TurtleRobot}
 * @implements pm.IsoRobotSprite
 */
var TurtleRobotSprite = pm.OrthoRobotSprite.extend(/** @lends TurtleRobotSprite# */{
	ctor: function()
	{
		cc.animationCache.addAnimations("Robot/kumir_robot-animations.plist");

		pm.spriteUtils.addTempSpriteFrames("Robot/turtle_robot.plist"); // TODO registerTempSpriteFrames
		pm.spriteUtils.registerTempSpriteFrames("Robot/kumir-indicate.plist");
		pm.spriteUtils.registerTempSpriteFrames("Robot/kumir_robot-broken.plist");
		pm.spriteUtils.registerTempSpriteFrames("Robot/kumir_robot-paint.plist");

		this._super(cc.spriteFrameCache.getSpriteFrame(this._getFrameName(0)));

		this._minPoint = cc.p(25, 25);
		this._maxPoint = cc.p(25, 25);

		this._commandsSprite.setOpacity(0);
	},

	_getActiveSpritePosition: function()
	{
		return cc.p(25, 57);
	},

	_getCommandsSpritePosition: function()
	{
		return cc.p(25, 25);
	},

	_getFrameName: function(direction)
	{
		return "turtle_robot0.png";
	},

	_getDestroyAnimationName: function(direction)
	{
		return "kumir_robot_d_2";
	},

	_getIndicateAnimationName: function(direction)
	{
		return "kumir_robot_i_0";
	},

	//getRealPosition: function(x,y)
	//{
	//    return this.mapLayer.realPosition(x, y, -35, 35);
	//},

	playAnimation: function(callback, target, type, args)
	{
		switch(type)
		{
			case TurtleRobotAnimation.Paint: this._paint(args, callback, target); break;
			default: pm.OrthoRobotSprite.prototype.playAnimation.call(this, callback, target, type, args); break;
		}
	},

	_turn: function(params, curDirection, endCallback, target)
	{
		var speedRatio = Math.abs(params.angle) / 90;

		var turn = cc.rotateBy(speedRatio * pm.settings.getAnimationSpeed(), params.angle);
		if (!params.clockwise)
			turn = turn.reverse();

		var turnEnd = cc.callFunc(endCallback, target);
		this.sprite.runAction(cc.sequence(turn, turnEnd));

		this._commandsSprite.runAction(cc.rotateTo(speedRatio * pm.settings.getAnimationSpeed(), -this._getTurnAngle(curDirection)));
	},

	_move: function(pos, endCallback, target)
	{
		if (!target.getTailFlag())
		{
			pm.RobotSprite2D.prototype._move.call(this, pos, endCallback, target);
			return;
		}

		var targetPos = this.getRealPosition(pos);
		var callback = cc.callFunc(endCallback, target);
		var moveEnd = cc.callFunc(function()
		{
			this._needToUpdateZOrder = false;
		}, this);

		var oldPos = this.getSprite().getPosition();
		var mapElementSize = target.parentLevel.activeMap.mapLayer.getMapElementSize();

		var diffPosX = (targetPos.x - oldPos.x) / mapElementSize.width;
		var diffPosY = (targetPos.y - oldPos.y) / mapElementSize.height;

		var speedRatio = Math.sqrt(diffPosX * diffPosX + diffPosY * diffPosY);
		var moveRobot = cc.moveTo(speedRatio * pm.settings.getAnimationSpeed(), targetPos);

		var length = Math.sqrt((targetPos.x - oldPos.x) * (targetPos.x - oldPos.x) + (targetPos.y - oldPos.y) * (targetPos.y - oldPos.y));
		var rotationAngle = cc.radiansToDegrees(Math.acos((targetPos.x - oldPos.x) / length));

		if (targetPos.y - oldPos.y > 0)
			rotationAngle *= -1;

		var line = new cc.Scale9Sprite("System/Line.png");

		line.setAnchorPoint(cc.p(0, 0.5));
		line.setRotation(rotationAngle);
		line.setPosition(cc.p(oldPos.x - (targetPos.x - oldPos.x) / length,oldPos.y - (targetPos.y - oldPos.y) / length));
		target.parentLevel.activeMap.mapLayer.drawLayer.addChild(line);

		var scaleLine = cc.scaleTo(speedRatio * pm.settings.getAnimationSpeed(), (length + 2) / line.width, 1);

		var moveAction = cc.targetedAction(this.getSprite(), moveRobot);
		var scaleAction = cc.targetedAction(line, scaleLine);

		this._needToUpdateZOrder = true;
		this.getSprite().runAction(cc.sequence(cc.spawn(moveAction, scaleAction), moveEnd, callback));
	},

	_getTurnAngle: function(direction)
	{
		return 360 - direction;
	},

	setActive: function(flag)
	{
		this._activeCircleSprite.setVisible(flag);
		this._activeSprite.setVisible(flag);
	},

	showCommands: function(flag, count)
	{
		if (flag && MethodStackLayer.opened)
			return;

		if (flag)
			this._commandsCount.setString(count);

		this._commandsSprite.setVisible(flag);
	}
});
